import { setUID } from "../../redux/userSlice";
import { store } from "../../store/store";
import { setAdminLoggerUserId } from "../../utils/logging/FrontendLoggerFactory";
import { subScribeToAuthStateChange } from "../firebase";

import { clearMessagingSendCustody } from "@/utils/messagingSendAttemptCustody";
import { clearPersonalDraftCustody } from "@/utils/personalDraftAttemptCustody";

/**
 * CRITICAL: Auth <-> Store Synchronization
 *
 * This logic was moved here from firebase.ts to break a circular dependency.
 *
 * The cycle was:
 * firebase.ts -> store -> baseApi -> MemoizedAuth -> firebase.ts
 *
 * resulting in: Uncaught ReferenceError: Cannot access 'auth' before initialization
 *
 * DO NOT move this logic back to firebase.ts.
 */
export const initAuthStoreSync = () => {
  let previousUid: string | undefined;
  subScribeToAuthStateChange((user) => {
    const nextUid = user?.uid ?? "";
    if (!nextUid || (previousUid !== undefined && previousUid !== nextUid)) {
      clearMessagingSendCustody();
      clearPersonalDraftCustody();
    }
    previousUid = nextUid;
    store.dispatch(setUID(nextUid));
    setAdminLoggerUserId(nextUid || undefined);
  });
};
